export const CURRENCIES = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'CAD', label: 'CAD' },
  { value: 'AUD', label: 'AUD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'BRL', label: 'BRL' },
  { value: 'MXN', label: 'MXN' },
] as const;

export const CURRENCY_SYMBOLS: Record<CurrencyCode, string> = {
  USD: '$',
  EUR: '€',
  CAD: '$',
  AUD: '$',
  GBP: '£',
  BRL: '$',
  MXN: '$',
} as const;

export type CurrencyCode = (typeof CURRENCIES)[number]['value'];

export const DEFAULT_CURRENCY: CurrencyCode = 'USD';

export const normalizeCurrencyCode = (candidate: unknown): CurrencyCode => {
  return CURRENCIES.some(({ value }) => value === candidate)
    ? (candidate as CurrencyCode)
    : DEFAULT_CURRENCY;
};
